import { Vue } from 'vue-property-decorator';
// http://numeraljs.com/
import numeral from 'numeral';
Vue.filter('numeric', function (value, format) {
    if (format === void 0) { format = '0,0'; }
    return numeral(value).format(format);
});
